import React from "react";
import Slider from "react-slick";
import "../components/CostSlider.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import {  Container } from 'react-bootstrap';

//Import Images
import slider1 from '../assets/image/card6.svg'; 
import slider2 from '../assets/image/card5.svg';
import slider3 from '../assets/image/card3.svg';
import { SliderRightArrow ,SliderLeftArrow} from '../components/SvgIcons';
const NextArrow = (props) => {
  const { onClick } = props;
  return <div className="custom-arrow right" onClick={onClick}> <SliderRightArrow/> </div>;
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return <div className="custom-arrow left" onClick={onClick}> <SliderLeftArrow/>  </div>;
};

const fallbackSlides = [
  {
    img: slider1,
    title: "(5N/6D) Ex. Kuala Lumpur",
    price: "INR 32,999/-",
    tagline: "Malaysia: Urban Oasis - Skyscrapers, Rainforests, & Diverse Cuisines."
  },
  {
    img: slider2,
    title: "(4N/5D) Ex. Penang",
    price: "INR 28,999/-",
    tagline: "Explore historic charm, beaches, and street food delights."
  },
  {
    img: slider3,
    title: "(6N/7D) Ex. Langkawi",
    price: "INR 36,999/-",
    tagline: "Island paradise with mountains, beaches, and duty-free shopping."
  }
];

function normalizePrice(value) {
  if (value === null || value === undefined || value === '') {
    return 'Price on request';
  }

  const stringValue = String(value).trim();
  return /inr|rs|₹|\$/i.test(stringValue) ? stringValue : `INR ${stringValue}`;
}

const CostSlider = ({ tours = [] }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  const sliderData = tours.length
    ? tours.map((tour, index) => ({
        img: tour.image_url || [slider1, slider2, slider3][index % 3],
        title: tour.name || 'Tour Package',
        price: normalizePrice(tour.price),
        tagline: tour.description || tour.location || tour.duration || 'Tour package details available on enquiry.',
      }))
    : fallbackSlides;

  return (
    <Container>
    <div className="slider-container costSlider">
      <Slider {...settings}>
        {sliderData.map((item, index) => (
          <div className="slide" key={index}>
            <img
              src={item.img}
              alt={item.title}
              className="background-img"
            />
             <div className="overlay-layer"></div>
            <div className="overlay-content">
            <div className="heading-borderLeft">
              <p className="tagline">{item.tagline}</p>
              <h1 className="title">{item.title}</h1>
              </div>
              <p className="price">{item.price} PER PERSON COST</p>
              <a href="#inquire-now" className="book-btn">Book now</a>
              <p className="tnc">*T&C Apply</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
    </Container>
  );
};

export default CostSlider;
